import { getAllOrgs } from './orgs.api';

export const getAllOrgsQuery = (populate: boolean = false) => ({
  queryKey: ['orgs', { populate }],
  queryFn: () => getAllOrgs(populate),
});
